import { request } from '@/shared'

export const getBillingSession = (plan: 'monthly' | 'yearly') => request<{ url: string }>('post', '/billing', { plan })
